import React, { useEffect, useState } from "react";
import { http } from "../lib/api";
import { AlertCircle, Calendar } from "lucide-react";

export default function AdminRenovaciones() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(90);

  useEffect(() => {
    setLoading(true);
    http.get(`/admin/renovaciones?days=${days}`).then((r) => setItems(r.data || [])).finally(() => setLoading(false));
  }, [days]);

  return (
    <div data-testid="admin-renovaciones">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Manrope" }}>Renovaciones</h1>
          <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Pólizas próximas a vencer. Ordenadas por urgencia.</p>
        </div>
        <div className="flex gap-2">
          {[30, 60, 90, 180].map((d) => (
            <button key={d} onClick={() => setDays(d)} className={`yn-btn ${days === d ? "yn-btn--active-yes" : ""}`} data-testid={`filter-${d}d`}>
              {d}d
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white border rounded-xl overflow-hidden" style={{ borderColor: "var(--border-subtle)" }}>
        {loading ? <div className="p-10 text-center text-sm" style={{ color: "var(--text-muted)" }}>Cargando…</div>
         : items.length === 0 ? (
          <div className="p-10 text-center">
            <Calendar size={36} className="mx-auto mb-3" style={{ color: "var(--text-muted)" }}/>
            <div className="font-bold mb-1" style={{ fontFamily: "Manrope" }}>Ninguna renovación en los próximos {days} días</div>
            <div className="text-sm" style={{ color: "var(--text-muted)" }}>Carga clientes con pólizas activas para ver alertas aquí.</div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="tbl">
              <thead><tr><th>Cliente</th><th>Tipo</th><th>Seguro</th><th>Compañía</th><th>Nº póliza</th><th>Renovación</th><th>Días</th><th>Prima UF</th><th>Estado</th></tr></thead>
              <tbody>
                {items.map((r, i) => (
                  <tr key={i}>
                    <td className="font-semibold">{r.cliente_nombre}</td>
                    <td className="capitalize text-[13px]">{r.cliente_tipo}</td>
                    <td className="text-[13px]">{r.tipo_seguro?.replace(/_/g, " ")}</td>
                    <td className="text-[13px]">{r.compania}</td>
                    <td className="font-mono text-[12px]">{r.numero_poliza}</td>
                    <td className="text-[13px]">{r.fecha_renovacion}</td>
                    <td>
                      <span className="font-bold text-[14px]" style={{ color: r.dias_restantes < 0 ? "#D32F2F" : r.dias_restantes <= 30 ? "#F57C00" : "var(--text-primary)" }}>
                        {r.dias_restantes < 0 ? `${Math.abs(r.dias_restantes)}d vencida` : `${r.dias_restantes}d`}
                      </span>
                    </td>
                    <td>{r.prima_anual_uf ? `UF ${r.prima_anual_uf.toFixed(1)}` : "—"}</td>
                    <td><span className={`badge badge--${r.estado}`}>{r.estado}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {items.filter((r) => r.dias_restantes <= 30 && r.dias_restantes >= 0).length > 0 && (
        <div className="mt-6 p-4 rounded-xl border flex items-start gap-3" style={{ borderColor: "rgba(245,124,0,0.3)", background: "rgba(245,124,0,0.05)" }}>
          <AlertCircle size={18} style={{ color: "#F57C00" }} className="mt-0.5 flex-shrink-0"/>
          <div className="text-sm">
            <div className="font-bold mb-1" style={{ fontFamily: "Manrope" }}>Atención: pólizas por vencer</div>
            <div style={{ color: "var(--text-muted)" }}>Hay pólizas que vencen en los próximos 30 días. Contacta a los clientes para gestionar la renovación.</div>
          </div>
        </div>
      )}
    </div>
  );
}
